import React from 'react'
import ListDragByConfig from '../../DragAndDropList/presents/ListDragByConfig'
import EditPrintTypesDragSwitch from './EditPrintTypesDragSwitch'
import ListDropItems from '../../DragAndDropList/presents/ListDropItems'
import { MOVIE } from '../../../constants/itemTypes'
import ButtonSubmit from '../../general/ButtonSubmit'
import requestStatus from '../../../constants/requestStatus'
import Translation from '../../Translation/cont/Translation'
import MoviesFilterActionsContainer from '../../DragAndDropList/cont/MoviesFilterActionsContainer'
import WrapperPageSpinner from '../../WrapperPage/present/WrapperPageSpinner'
import { SHOWCASEREDUCED } from '../../../constants/printType'


const conditionalWrapper = () => (children) => (
    <div className="periode-list">
        <div className="periode-item-container">
            {children}
        </div>
    </div>
)


const EditPrintTypes = ({
    printTypeNameTransId,
    printFormatNameTransId,
    status,
    errorMsg,
    basicUrl,
    features,
    printType,

    closePagePath,
    dragListConfig,
    movieFilterConfig,
    itemsData,
    itemsDataCallback,

    displayDropzones,
    disableButton,

    onAddItem,
    onReorderItem,
    onDeleteItem,
    onPdfRequest,
    onPdfReset
}) => {
    const pageName = [<Translation key="name" id={printTypeNameTransId} after=" in "/>, <Translation key="format" id={printFormatNameTransId}/>]
    const listId = 'fooo'  /// ??? ToDo

    const displayDropzonesClass = displayDropzones ? ' dropzones single-dropzone' : ''

    const { INITIALIZED, REQUEST_PENDING, REQUEST_SUCCESS, REQUEST_ERROR } = requestStatus

    let buttonTextTransId

    if(INITIALIZED === status) {
        buttonTextTransId = 'print_generate_PDF'
    } else if(REQUEST_PENDING  === status) {
        buttonTextTransId = 'print_PDF_is_generated'

    } else if(REQUEST_SUCCESS === status)  {
        buttonTextTransId = 'print_PDF_was_generated'
    } else {
        buttonTextTransId = 'print_PDF_error'
    }

    return (
        <WrapperPageSpinner
            pageTitle={pageName}
            closePagePath={closePagePath}
        
            pending={REQUEST_PENDING  === status}
            error={REQUEST_ERROR === status}
            success={REQUEST_ERROR === status}
        
            pendingTextTransId='print_PDF_is_generated'
            errorTextTransId='print_error_occurred_while_generating'
            successTextTransId='print_PDF_successfully_generated'
            
            errorMsg={errorMsg ? errorMsg.message : ''}
            successMsg='Es befindet sich in dem Downloadordner oder ist über die Downloadhistorie des Browsers zu finden. Je nach Downloadeinstellung kann sich der Speicherort unterscheiden.'
        
            onClickSuccesButton={onPdfReset}
            onClickErrorButton={onPdfReset}
        >
            <div className="program-page program-page-edit-selection site-content">
                {((printType === SHOWCASEREDUCED && features && features.has_showcaseReduced) || printType !== SHOWCASEREDUCED) ?
                <div className="selections-item">
                    <div className="selections-item-content accordion-item">
                        <p className="selection-drag-hint title-large-light"><Translation id="section_page_drag_movies_to_sort"/></p>

                        <div className={"selections-item-selections section-left" + displayDropzonesClass}>
                            <MoviesFilterActionsContainer
                                filterConfig={movieFilterConfig}
                                listId={listId} ///? 

                                relevantAttributes={itemsData.attributes}
                                relevantMovies={itemsData.moviesOrder}
                                currentMovies={itemsData.currentMovies}
                                futureMovies={itemsData.futureMovies}
                                selectedItems={itemsData.selectedItems}
                                addItem={onAddItem}
                                deleteItem={(listId, itemId, targetId) => onDeleteItem(itemId)}
                            />

                            <ListDragByConfig
                                dragListConfig={dragListConfig}
                                itemsData={itemsData}
                                itemsDataCallback={itemsDataCallback}
                                basicUrl={basicUrl}
                                defaultIsOpen={true}
                                ChildSwitchItem={EditPrintTypesDragSwitch}
                                addNewItem={onAddItem}
                                onDeleteItem={onDeleteItem}
                            />
                        </div>

                        <div className={"selections-item-periodes section-right" + displayDropzonesClass}>
                            <ListDropItems
                                listId={listId} ///?
                                title = ''
                                items={itemsData.moviesItems}
                                order={itemsData.selectedItems}
                                itemType={MOVIE}
                                displayDropzones={displayDropzones}
                                conditionalWrapper={conditionalWrapper}
                                ChildSwitchItem={EditPrintTypesDragSwitch}
                                basicUrl={basicUrl}
                                canEdit={true}
                                canDelete={true}
                                addItem={onAddItem}
                                reorderItem={onReorderItem}
                                deleteItem={onDeleteItem}
                            />
                        </div>
                    </div>

                    <div className={"save-program-button" + (disableButton ? " disabled" : "")}>
                        <ButtonSubmit
                            transIdSubmit={disableButton ? "select_movie_button" : buttonTextTransId}
                            onSubmit={() => !disableButton && onPdfRequest()}
                            disableTemporarily={disableButton}
                            disablePermanently={false}
                        />
                    </div>
                    
                </div> : (
                    <div>Dieses Feature ist nicht freigeschaltet. Bei Interesse kontaktieren Sie unseren <a className="support-mail text-regular-color cursor-pointer" href="mailto:info@pmkino.com">Support</a>.</div>
                )}
            </div>
        </WrapperPageSpinner>
    )
}

export default EditPrintTypes

